var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"name":"fade"}},[(_vm.showLoader)?_c('PageLoader'):_vm._e()],1),_vm._v(" "),_c('nuxt',{staticClass:"empty-frame-page"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }